<template >
  <modal v-model="value.show">
    <div slot="content">
    <form @submit.prevent="validateBeforeSubmit">
      <div class="ls-modal-header">
        <button close-modal data-dismiss="modal">&times;</button>
        <h4 class="ls-modal-title">{{ $t('invoices.modal_cancelation.title') }}</h4>
      </div>
      <div class="ls-modal-body">
        <div v-html="$t('invoices.modal_cancelation.info')"></div><br>
        <h5 class="ls-label-text ls-sm-margin-bottom">{{ $t('invoices.modal_reverse.nf_info') }}</h5>
          <div class="row">
            <label class="ls-label col-md-12" :class="{'ls-error': errors.has($t('invoices.modal_cancelation.observation')) }">
              <span class="ls-label-text">{{ $t('invoices.modal_cancelation.include_observation') }}</span>
              <textarea
                v-validate="'required'"
                rows="4"
                v-model="observation"
                :name="$t('invoices.modal_cancelation.observation')">
              </textarea>
              <small class="ls-help-message" v-show="errors.has($t('invoices.modal_cancelation.observation'))">{{ errors.first($t('invoices.modal_cancelation.observation')) }}</small>
            </label>
          </div>
        </div>
        <div class="ls-modal-footer">
          <button type="button" class="ls-btn" close-modal data-dismiss="modal">{{ $t('application.button.close') }}</button>
          <button type="submit" class="ls-btn ls-float-right">{{ $t('invoices.modal_cancelation.confirm') }}</button>
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
  import Modal from 'src/app/components/shareds/modal/Modal'
  import { mapActions } from 'vuex'

  export default {
    props: ['value'],
    components: { Modal },
    data () {
      return {
        observation: '',
        errorClass: ''
      }
    },
    methods: {
      ...mapActions(['cancelInvoice']),
      sendInvoiceCancelation (success) {
        if (!success) return

        this.$loader.show()
        this.value.show = false
        var params = { invoice_id: this.$parent.invoiceId, observation: this.observation }
        this.cancelInvoice(params).then(this.$parent.getInvoice)
      },
      validateBeforeSubmit () {
        this.$validator.validateAll().then(this.sendInvoiceCancelation)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalCancelation.vue?1f7578cc